import React, { Fragment, useState } from 'react';
import moment from 'moment';
import { Button, Paper, Grid } from '@material-ui/core';
import { DialWidgetCard } from '../../Elements';
import { displayDateFormatShort } from '../../../constants';
import EngineFutureProjectionsModal from './EngineFutureProjectionsModal';

const formatDial = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num.toFixed(3) : null;
};

const EngineValuationOutput = ({ logResult }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const showBv = logResult.show_bv_cmv !== false;
  const showBlr = !!logResult.is_blr_mlr;

  return (
    <Fragment>
      <div className="bv-fbv-output engine-valuation-output">
        <Paper className="output-fbv-card engine-projection-header">
          <div>
            <h4>Future Projection Values</h4>
            {logResult.projection_to ? (
              <p>Projection Till: <span>{moment(logResult.projection_to).format(displayDateFormatShort)}</span></p>
            ) : null}
          </div>
          <div className="engine-output-actions">
            <Button onClick={() => setModalOpen(true)} color="primary" variant="contained" size="small">Show</Button>
          </div>
        </Paper>

        <p className="engine-value-as-of">Value as of: {moment(logResult.base_value_date).format(displayDateFormatShort)}</p>

        {showBv ? (
          <Fragment>
            <Paper className="output-widget-card engine-result-card">
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <DialWidgetCard value={formatDial(logResult.base_value)} label="Half Life" unit="m" />
                </Grid>
                <Grid item xs={6}>
                  <DialWidgetCard value={formatDial(logResult.full_life_base_value)} label="Full Life" unit="m" />
                </Grid>
              </Grid>
              <h4 className="engine-card-caption">Current Base Value</h4>
            </Paper>

            <Paper className="output-widget-card engine-result-card">
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <DialWidgetCard value={formatDial(logResult.cmv_value)} label="Half Life" unit="m" />
                </Grid>
                <Grid item xs={6}>
                  <DialWidgetCard value={formatDial(logResult.full_life_cmv_value)} label="Full Life" unit="m" />
                </Grid>
              </Grid>
              <h4 className="engine-card-caption">Current Market Value</h4>
            </Paper>
          </Fragment>
        ) : null}

        {showBlr ? (
          <Paper className="output-widget-card engine-result-card">
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <DialWidgetCard value={logResult.blr_value != null ? Number(logResult.blr_value) : null} label="Base Lease Rate" unit="k" precision={3} />
              </Grid>
              <Grid item xs={6}>
                <DialWidgetCard value={logResult.mlr_value != null ? Number(logResult.mlr_value) : null} label="Market Lease Rate" unit="k" precision={3} />
              </Grid>
            </Grid>
            <h4 className="engine-card-caption">Lease Rate (BLR &amp; MLR)</h4>
          </Paper>
        ) : null}
      </div>

      <EngineFutureProjectionsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        logResult={logResult}
      />
    </Fragment>
  );
};

export default EngineValuationOutput;
